<div class="deregistration-pack-details-view-container" *ngIf="deregistrationPackObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="deregistrationPackObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + deregistrationPackObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="deregistrationPackObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).deregistration.write || processingRequest" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button *ngIf="(userPermissions | async).deregistration.delete" [disabled]="!(userPermissions | async).deregistration.delete || processingRequest || deregistrationPackObject.status.key === DEREGISTRATION_PACK_STATUS_SENT" (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
    <button [disabled]="!(userPermissions | async).deregistration.write || processingRequest"
            (click)="confirmDeregistration()" mat-stroked-button color="primary"><span>Potwierdzenie wyrejestrowania</span></button>
    <button  [disabled]="!(userPermissions | async).deregistration.delete|| processingRequest || deregistrationPackObject.status.key === DEREGISTRATION_PACK_STATUS_SENT" (click)="generatePartnerDataDocuments()"mat-stroked-button color="primary"><span> Generowanie dokumentów wyrejestrowań</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane paczki</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="TU" [value]="deregistrationPackObject.insuranceCompany?.name"
                          [link]="['/tu/szczegoly', deregistrationPackObject.insuranceCompany?.id]"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Firma" [value]="deregistrationPackObject.company?.name"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Szczegóły</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Data wysłania" [value]="deregistrationPackObject.sentAt | date:'y-MM-dd'"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Data utworzenia" [value]="deregistrationPackObject.createdAt | date:'y-MM-dd'"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      </div>

    </div>
  </div>
